import { CustomTabList, Heading } from "@/components";
import { Card, Tabs, TabsContent } from "@/components/ui";
import { tabs } from "./consts";
import { TaskAssignment, TaskConfig, MyTasks } from "./TabsData";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { LOGIN_ROLES } from "@/lib/utils";

const MasterData = () => {
  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );

  // 👇 backend sends role as array, e.g. ["CRM_HEAD"]
  const roles = loggedInUserData?.role || [];

  // Helper to check if user has a given role
  const hasRole = (role: string) =>
    Array.isArray(roles) && roles.includes(role);

  // 🧠 Determine visible tabs
  let visibleTabs = tabs;

  if (
    hasRole(LOGIN_ROLES.FINANCE_TEAM) ||
    hasRole(LOGIN_ROLES.LABS_TEAM) ||
    hasRole(LOGIN_ROLES.INVENTORY_TEAM) ||
    hasRole(LOGIN_ROLES.RELATIONSHIP_MANAGER) ||
    hasRole(LOGIN_ROLES.LABS_TEAM_HEAD) ||
    hasRole(LOGIN_ROLES.CRM_HEAD)  ||
    hasRole(LOGIN_ROLES.REGION_HEAD) ||
    hasRole(LOGIN_ROLES.SALES_OPS)
  ) {
    // SALES_OPS or FINANCE_TEAM → only MyTasks
    visibleTabs = tabs.filter((tab) => tab.value === "3");
  } else if (
    hasRole(LOGIN_ROLES.SUPER_ADMIN) 
  ) {
    // CRM_HEAD → all tabs
    visibleTabs = tabs;
  } else {
    // Others → hide MyTasks
    visibleTabs = tabs.filter((tab) => tab.value !== "3");
  }

  return (
    <div className="p-7">
      <Heading title="Task Management" />

      <Card className="py-5 pt-0 mt-6 shadow-none">
        <Tabs defaultValue={visibleTabs[0]?.value} className="mt-6 flex">
          <CustomTabList tabs={visibleTabs} className="mx-5" />

          {/* ✅ Show TaskConfig & TaskAssignment if not SALES_OPS or FINANCE_TEAM */}
          {!(
            hasRole(LOGIN_ROLES.SALES_OPS) || hasRole(LOGIN_ROLES.FINANCE_TEAM)
          ) && (
            <>
              <TabsContent value="1" className="px-0">
                <TaskConfig />
              </TabsContent>

              <TabsContent value="2" className="px-0">
                <TaskAssignment />
              </TabsContent>
            </>
          )}

          {/* ✅ MyTasks tab */}
          <TabsContent value="3" className="px-0">
            <MyTasks />
          </TabsContent>
        </Tabs>
      </Card>

      <Outlet />
    </div>
  );
};

export default MasterData;
